import { Row, Col } from 'react-bootstrap';
import Withdraw from '../../../../styles/images/withdraw.png';
import WithdrawPending from '../../../../styles/images/withdraw_pending.png';
import Deposit from '../../../../styles/images/deposite.png';
import DepositPending from '../../../../styles/images/deposite-pending.png';

const CardWalletTrans = (props) => {

    const {amount, amount_string, date, description, status} = props.data.item;
    const imageSrc = ( status == "done" ? (amount > 0 ? Deposit : Withdraw) : (amount >= 0 ? DepositPending : WithdrawPending) );
    return (

        <div className="w-100 p-3 wallet-trans d-flex mb-2">
            <div className="justify-content-center">
                <img src={imageSrc} width={40} alt="وضعیت تراکنش" />
            </div>
            <div className="w-100 d-flex flex-column justify-content-center">
                <Row className="w-100 mx-0 pb-2">
                    <Col xs={6} className="text-left">{amount_string} </Col>
                    <Col xs={6} className="text-right p-0">{date}</Col>
                </Row>
                <Row className="ml-3">
                    <Col className="top-dash-border" />
                </Row>
                <Row className="w-100 mx-0 pt-2">
                    <Col className="text-left" style={{paddingLeft: "0"}} dangerouslySetInnerHTML={{ __html: description }} />
                </Row>
            </div>
        </div>
    );
}

export default CardWalletTrans;